
import React from 'react';
import { Button } from '@/components/ui/button';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PlusCircle } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
  icon?: React.ReactNode;
}

export function EmptyState({ 
  title, 
  description, 
  actionLabel,
  onAction,
  icon
}: EmptyStateProps) {
  return (
    <div className="w-full flex flex-col items-center justify-center py-12 px-4 rounded-lg border border-dashed border-gray-300 bg-gray-50/50 text-center animate-in fade-in-50 duration-300">
      {icon && (
        <div className="mb-4 text-muted-foreground">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-medium mb-2">{title}</h3>
      <p className="text-muted-foreground mb-6 max-w-md">{description}</p>
      <Button onClick={onAction} className="gap-2">
        <PlusCircle className="h-4 w-4" />
        {actionLabel}
      </Button>
    </div>
  );
}
